export default __webpack_public_path__ + "static/media/USD.79767c51.svg";